import { AssignmentStage } from 'constants/assignment'
import { Auth0Roles } from 'models/auth'
import i18n from 'translations/i18n'

export const translateAssignmentStage = (stage: AssignmentStage, roles: Auth0Roles) => {
  return i18n.t(`assignment_stage:${roles.isClient ? 'client' : roles.isCreative ? 'creative' : 'admin'}:${stage}`)
}